class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.header = document.querySelector('header');

        this.btnOpenMenu = this.header.querySelector('.btnOpenMenu')
        this.menu = this.header.querySelector('.primary-menu')

        this.mobileMenu()

    }
    
    mobileMenu() {
        this.btnOpenMenu.addEventListener('click', () => {
            this.header.classList.toggle('active')
            // this.btnOpenMenu.classList.toggle('active')
            // this.menu.classList.toggle('active')
        })
    }

}

new Header();